<ul *ngIf="restrictionExclusions$ | ngrxPush; let restrictionExclusions">
    <li *ngIf="restrictionExclusions.isManagedByGovernment">
        <dtm-ui-icon name="check"></dtm-ui-icon>
        {{ "dssSharedLibFlightZone.applicationSummary.uavPurpose.managedByGovernmentLabel" | transloco }}
    </li>
    <li *ngIf="restrictionExclusions.isAgreedExclusion">
        <dtm-ui-icon name="check"></dtm-ui-icon>
        {{ "dssSharedLibFlightZone.applicationSummary.uavPurpose.agreedExclusionLabel" | transloco }}
    </li>
    <li *ngIf="restrictionExclusions.areOwnedFlights">
        <dtm-ui-icon name="check"></dtm-ui-icon>
        {{ "dssSharedLibFlightZone.applicationSummary.uavPurpose.ownedFlightsLabel" | transloco }}
    </li>
    <li *ngIf="restrictionExclusions.uavMtomExclusion">
        <dtm-ui-icon name="check"></dtm-ui-icon>
        {{
            "dssSharedLibFlightZone.applicationSummary.uavMtomExclusionLabel"
                | transloco
                    : {
                          from: restrictionExclusions.uavMtomExclusion.from,
                          to: restrictionExclusions.uavMtomExclusion.to
                      }
        }}
    </li>
    <li *ngIf="restrictionExclusions.courses.length">
        <dtm-ui-icon name="check"></dtm-ui-icon>
        {{ "dssSharedLibFlightZone.applicationSummary.coursesLabel" | transloco }}:
        {{ restrictionExclusions.courses | invoke : formatCoursesToDisplay }}
    </li>
    <li *ngIf="restrictionExclusions.operatorAuthorizations.length">
        <dtm-ui-icon name="check"></dtm-ui-icon>
        {{ "dssSharedLibFlightZone.applicationSummary.operatorAuthorizationsLabel" | transloco }}:
        {{ restrictionExclusions.operatorAuthorizations | join }}
    </li>
    <li *ngIf="restrictionExclusions.otherExclusion">
        <dtm-ui-icon name="check"></dtm-ui-icon>
        {{ "dssSharedLibFlightZone.applicationSummary.otherExclusionLabel" | transloco }}:
        {{ restrictionExclusions.otherExclusion }}
    </li>
</ul>
